import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'haTemplateFilter'
})
export class HaTemplateFilterPipe implements PipeTransform {

  transform(doctorData: any[], searchTerm: string): any[]{
    if (!doctorData || !searchTerm) { return doctorData; }
    return doctorData.filter(ad =>
     
    
      ad.name.toLowerCase().indexOf(searchTerm.toLowerCase().trim()) !== -1
     




    );
  }

}
